// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__p5bse","alertIcon":"ConfirmModal_alertIcon__14FQK"};